import "./_import_files"
import $ from "jquery";
import "objectFitPolyfill";
import svg4everybody from "svg4everybody";
import Page from "webPage/Page";
import "./settings";


$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }
    $("body").addClass("has-js").removeClass("no-js");

    Page.init();
    svg4everybody();

    appHeight();
});

function appHeight() {
    let doc = document.documentElement;
    doc.style.setProperty('--screen-height', $(window).innerHeight() + 'px');
}
